import React from 'react';

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  name: string | null | undefined;
  addBefore?: string;
}

export default function HotelJapaneseName({ className, name, addBefore, ...props }: Props) {
  if (!name) {
    return null;
  }
  return <span {...props} className={`${className || ''} hotel-japanese-name`}>{`${addBefore ? ' ' + addBefore + ' ' : ''}${name}`}</span>;
}
